// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogJa = {
  "controls": {
    "boot": "起動",
    "reset": "リセット",
    "copyScreen": "画面をコピー",
    "copyText": "テキストをコピー",
    "pasteText": "テキストを貼り付け",
    "saveState": "状態を保存",
    "restoreState": "状態を復元",
    "toggleSound": "音声切替",
    "settings": "設定",
    "debugPanel": "デバッグパネル",
    "infoPanel": "情報パネル",
    "reportIssue": "問題を報告",
    "privacyPolicy": "プライバシーポリシー"
  },
  "config": {
    "speed": "速度",
    "display": "表示設定",
    "theme": "テーマ",
    "openRetroControlPanel": "コントロールパネル",
    "resetSettings": "全設定をリセット",
    "useOpenApple": "{{modKey}}キーをOpen Appleキーとして使用",
    "useShortcuts": "{{modKey}}キーをキーボードショートカットに使用",
    "useArrowKeys": "矢印キーをジョイスティックとして使用",
    "scanlines": "CRTスキャンライン",
    "ghosting": "残光効果",
    "crtDistortion": "CRT歪曲",
    "joystick": "ジョイスティック設定"
  },
  "machine": {
    "slotConfigurator": "拡張スロット"
  },
  "speed": {
    "snail": "カタツムリ速度 (0.1 MHz)",
    "slow": "低速 (0.5 MHz)",
    "normal": "通常速度 (1 MHz)",
    "fast": "高速 (4 MHz)",
    "warp": "ばかげた速度"
  },
  "colors": {
    "color": "カラー",
    "nofringe": "カラー (フリンジなし)",
    "green": "緑",
    "amber": "アンバー",
    "white": "白黒",
    "inverse": "白黒 (反転)"
  },
  "themes": {
    "classic": "クラシック",
    "dark": "ダーク",
    "minimal": "ミニマル"
  },
  "debug": {
    "helpPanel": "ヘルプパネルを表示",
    "debugPanel": "デバッグパネルを表示",
    "expectinPanel": "Apple exPectinパネルを表示",
    "helpTab": "ヘルプ",
    "debugTab": "デバッグ",
    "breakpoints": "ブレークポイント",
    "memory": "メモリ",
    "stack": "スタック",
    "state": "CPU状態",
    "registers": "レジスタ",
    "flags": "フラグ",
    "step": "ステップ",
    "stepOver": "ステップオーバー",
    "stepInto": "ステップイン",
    "stepOut": "ステップアウト",
    "resume": "再開",
    "pause": "一時停止",
    "loadSymbolTable": "シンボルテーブルを読み込む",
    "disassembly": "逆アセンブル"
  },
  "tour": {
    "welcome": "Apple2TSエミュレータへようこそ！",
    "clickNext": "詳細を学ぶには、次へボタンを押してください。",
    "bootButton": "ここをクリックしてエミュレータを起動します。",
    "resetButton": "ここをクリックしてApple IIをリセットし、再起動またはBASICに入ります。",
    "diskImages": "インストールされているディスクイメージの1つを選択してください。",
    "floppyDisks": "またはフロッピーディスクアイコンの1つをクリックしてディスクイメージをロードします。",
    "saveRestore": "これらのボタンを使用してエミュレータの完全な状態を保存および復元できます。",
    "themeButton": "ここをクリックしてエミュレータUIテーマを変更します。",
    "endTour": "ツアーの終わりに到達しました。地球儀ツアーボタンをクリックして他のツアーを試すか、完了を押してエミュレータの使用を開始してください。",
    "tourSelectorHint": "地球儀ツアーボタンをクリックして他のツアーを試すか、終了を押してエミュレータの使用を開始してください。",
    "settingsWelcome": "Apple2TSはエミュレータとApple IIの両方に対する完全なコントロールセットを持っています。詳細を学ぶには、次へボタンを押してください。",
    "mainControls": "ここでは、Apple IIの起動とリセット、状態の復元と保存、画面のコピー、またはエミュレータへのテキスト貼り付けができます。",
    "snapshot": "いつでも現在のエミュレータ状態のスナップショットを取ることができ、その後以前の状態に戻ったり、再び早送りしたりできます。現在のすべてのスナップショットとともにエミュレータ状態を保存することもできます。",
    "pauseButton": "いつでもエミュレータを一時停止して、6502プロセッサを凍結することができます。これはゲームでアクションを一時停止したり、デバッガに入るのに便利です。",
    "debugButton": "バグをクリックしてデバッグモードに入り、6502プロセッサの内部状態を見ることができます。再度クリックして通常モードに戻ります。",
    "configButtons": "下の行のボタンはApple IIの状態を制御し、エミュレータ速度、画面の色、音声のミュートから始まります。",
    "keyboardButtons": "caps lockキーがオンになっている場合、入力されたすべての文字が大文字になります。",
    "altArrowKeys": "次のキーは{{modKey}}キーがキーボードショートカットまたはApple II Open Appleキーに使用されるかを決定します。最後のキーは矢印キーがApple IIジョイスティックとして使用できるかを決定します。",
    "clearCookies": "Apple2TSは現在のエミュレータ設定をブラウザクッキーとして自動的に保存します。このボタンを押してこれらの設定をリセットし、クッキーを削除します。",
    "debugWelcome": "Apple2TSは6502アセンブリコードを分析およびデバッグするための豊富なツールセットを持っています。詳細を学ぶには、次へボタンを押してください。",
    "debugIcon": "情報タブのバグアイコンをクリックしてデバッグパネルを表示します。",
    "debugPause": "一時停止ボタンを押してエミュレータの実行を一時停止または再開します。",
    "debugControls": "一時停止したので、ステップオーバー、イン、アウトボタンを使用して逆アセンブルされたコードをステップ実行できます。プログラムカウンタ（PC）の現在のアドレスに素早くジャンプすることもできます。",
    "debugDisassembly": "ここで逆アセンブルされたコードを16進アドレス、3文字の命令、および任意の値またはアドレスで見ることができます。緑の値の上にマウスを移動すると、現在の値を含むツールチップが表示されます。青いアドレスをクリックするとその場所にスクロールします。左の余白をクリックしてブレークポイントを追加または削除することもできます。",
    "debugInfo": "中央にスタックダンプとメモリマップがあります。メモリマップはリアルタイムで更新され、現在アクティブなメモリバンクを表示します。",
    "debugMemory": "最後のセクションはApple IIメモリを表示します。ドロップリストを使用してメモリの異なる部分を検査できます。HGRページの1つに切り替えると、メモリ位置に結び付けられた高解像度画面の拡大ビューが得られます。16進値やASCII文字列を検索し、メモリをファイルに保存することもできます。",
    "back": "戻る",
    "close": "閉じる",
    "last": "完了",
    "next": "次へ",
    "nextLabelWithProgress": "次へ ({steps} ステップ中の {step})",
    "skip": "閉じる",
    "guidedTour": "ガイド付きツアー",
    "mainLabel": "ガイド付きツアー：メイン",
    "settingsLabel": "ガイド付きツアー：設定",
    "debugLabel": "ガイド付きツアー：デバッグ"
  },
  "disk": {
    "drive1": "ドライブ1",
    "drive2": "ドライブ2",
    "hardDisk": "ハードディスク",
    "eject": "ディスクを取り出す",
    "insert": "ディスクを挿入",
    "writeProtected": "書き込み保護",
    "readWrite": "読み書き",
    "empty": "空",
    "loading": "ロード中...",
    "selectDisk": "ディスクイメージを選択",
    "browse": "参照",
    "newReleases": "新リリース",
    "writeProtectDisk": "ディスク書き込み保護",
    "saveDiskToDevice": "ディスクを保存",
    "saveDiskTo": "ディスクの保存先",
    "saveDiskToMenu": "ディスクの保存先 >",
    "addToFavorites": "お気に入りに追加",
    "downloadDisk": "ディスクをダウンロード",
    "downloadWoz": "WOZ ディスクイメージをダウンロード",
    "downloadAndEjectDisk": "ディスクをダウンロードして排出",
    "ejectDisk": "ディスクを排出",
    "ejectAllDisks": "すべてのディスクを排出",
    "saveDiskToOneDrive": "OneDriveにディスクを保存",
    "saveDiskToGoogleDrive": "Google Driveにディスクを保存",
    "loadDisk": "ディスクを読み込む",
    "loadAdditionalDisks": "追加ディスクを読み込む...",
    "loadDiskFrom": "ディスクの読み込み元",
    "loadDiskFromMenu": "ディスクの読み込み元 >",
    "loadDiskFromDevice": "ディスクを読み込み",
    "loadDiskFromDeviceReadOnly": "デバイスからディスクを読み込み (読み取り専用)",
    "loadDiskFromDeviceReadWrite": "デバイスからディスクを読み込み (読み書き)",
    "loadDiskFromInternetArchive": "Internet Archiveからディスクを読み込み",
    "loadDiskFromOneDrive": "OneDriveからディスクを読み込み",
    "loadDiskFromGoogleDrive": "Google Driveからディスクを読み込み",
    "insertBlankDisk": "ブランクディスクを挿入",
    "syncEveryMinute": "毎分同期",
    "syncEvery5Minutes": "5分ごとに同期",
    "pauseSyncing": "同期を一時停止",
    "syncNow": "今すぐ同期",
    "modified": "変更されました",
    "synced": "同期済み",
    "diskImage": "ディスクイメージ",
    "diskDrivesAndDevices": "ディスクドライブとデバイス",
    "syncedAt": "同期済み {{date}}",
    "clickToLoadDiskImage": "クリックしてディスクイメージを読み込む",
    "clickToRemoveFromDiskCollection": "クリックしてディスクコレクションから削除",
    "clickToAddToDiskCollection": "クリックしてディスクコレクションに追加",
    "byCreator": "作成者: {{creator}}",
    "clickToViewDetails": "クリックして詳細を表示",
    "standbyDisks": "待機ディスク (クリックしてディスクを変更)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "TypeScript Apple IIe エミュレータ",
    "credit": "(c) {{year}} Chris Torrence および Apple2TS コントリビューター",
    "keyboardShortcuts": "キーボードショートカット",
    "shortcutsUnavailable": "{{keyMod}} を使うエミュレータのショートカットは、このキーが Open Apple に割り当てられている間は使用できません。Ctrl+0 から Ctrl+5 では引き続きエミュレータの速度を選択できます。",
    "diskImages": "ディスクイメージ:",
    "diskContainers": "圧縮アーカイブ：",
    "multiDiskNotice": "複数ディスク入替：ドライブのマルチディスクバッジをクリックしてクイック入替メニューを開きます。複数ディスクを含むアーカイブ（.zip、.7z、.gz）は自動的に入替リストへ読み込まれます。",
    "urlParameters": "オプションのURLパラメータ",
    "examples": "例",
    "mobileInstructions": "モバイルプラットフォーム:",
    "tapScreen": "画面をタップしてキーボードを表示します。",
    "arrowKeys": "矢印キー、esc、またはtabボタンを押してこれらのキーをエミュレータに送信します。",
    "ctrlKey": "制御文字を送信するには、ctrlボタンを一度押します。その後、画面をタップしてキーボードを表示し、目的のキーを押します。ctrlボタンは自動的に解除されます。",
    "ctrlLock": "複数の制御文字を送信するには、ctrlボタンを2回押してロックします（緑の点で示されます）。その後、画面をタップしてキーボードを表示し、目的のキーを押します。ctrlボタンを再度押して解除します。",
    "appleKeys": "open appleおよびclosed appleキーはctrlキーと同じように動作します。",
    "openAppleKey": "Open Apple: 左Alt/Optionを押す",
    "closedAppleKey": "Closed Apple: 右Alt/Optionを押す",
    "joystickKeys": "ジョイスティック: テンキー 8/2/4/6 (7/9/1/3), 0/5, ./Enter",
    "onScreenKeyboard": "画面キーボードでCTRLやESCを使う場合は\nキーを一度タッチして有効化し、目的のキーを押してください。",
    "urlParametersBody": "オプションのURLパラメータは、URLにクエスチョンマーク(?)の後に追加し、複数のパラメータはアンパサンド(&)で区切ります。ディスクイメージの指定には#を使用します。例についてはリンクビルダーダイアログを参照してください。",
    "exampleLinks": {
      "totalReplayDebugging": "デバッグ付きTotal Replay",
      "totalReplayChoplifter": "Total Replay、Choplifterをロード、埋め込みモード",
      "a2Desktop": "高速・カラー表示のA2DeskTop 2MG",
      "embeddedBasic": "埋め込みApplesoft BASICプログラム",
      "binaryHexAddress": "Hexアドレス付きバイナリファイル"
    },
    "links": "リンク",
    "resourceLinks": {
      "desktopApp": "Apple2TS デスクトップアプリ",
      "corsProxy": "Corsfix による CORS プロキシ",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "ロード中...",
    "error": "エラー",
    "success": "成功",
    "confirm": "確認",
    "cancel": "キャンセル",
    "on": "オン",
    "off": "オフ",
    "confirmTheme": "エミュレータを再読み込みして、このテーマを今すぐ適用しますか？",
    "confirmReset": "すべての設定をデフォルト値にリセットしますか？",
    "fileNotFound": "ファイルが見つかりません",
    "invalidFile": "無効なファイル形式",
    "diskInserted": "ディスクが挿入されました",
    "diskEjected": "ディスクが取り出されました"
  },
  "keyboard": {
    "space": "スペース"
  },
  "audio": {
    "speaker": "スピーカー",
    "midi": "MIDI",
    "configuration": "オーディオ設定",
    "volume": "音量",
    "mute": "ミュート",
    "waveform": "波形"
  },
  "print": {
    "printer": "プリンタ",
    "print": "印刷",
    "clear": "クリア",
    "save": "出力を保存",
    "dumpScreen": "現在の画面をプリンタに出力",
    "dumpScreenInverse": "現在の画面を出力（反転）",
    "sendToPrinter": "プリンタに送信",
    "tearOff": "ページを切り取りリセット",
    "printedPage": "印刷されたページ",
    "printerConfig": "プリンタ設定",
    "pageLength": "ページの長さ",
    "pageLengthLetter": "11インチ（レター）",
    "pageLengthA4": "11.7インチ（A4）",
    "pageLengthTwelve": "12インチ"
  },
  "device": {
    "machineConfiguration": "マシン構成",
    "midiDeviceSelect": "MIDIデバイス選択",
    "serialPortSelect": "シリアルポート選択",
    "mockingboardWaveform": "Mockingboard波形"
  },
  "collection": {
    "showApple2TSCollection": "Apple2TSコレクションを表示",
    "showNewReleases": "新しいリリースを表示",
    "showFavorites": "お気に入りを表示",
    "chooseDiskImage": "ディスクイメージを選択",
    "diskCollection": "ディスクコレクション",
    "clickToShowDetails": "詳細を表示するにはクリック",
    "clickToLoadDisk": "ディスクを読み込むにはクリック",
    "diskIsNewRelease": "このディスクは新しいリリースです",
    "diskIsApple2TSCollection": "このディスクはApple2TSコレクションの一部です",
    "diskIsInternetArchive": "このディスクはInternet Archiveの一部です",
    "clickToRemoveFromCollection": "クリックしてディスクコレクションから削除",
    "clickToAddToCollection": "クリックしてディスクコレクションに追加",
    "diskIsSyncedVia": "ディスクは同期済みです",
    "loadDiskIntoDrive": "ドライブにディスクを読み込み",
    "exportDisksToHdv": "ディスクをHDVにエクスポート",
    "export": "エクスポート",
    "clickToRemoveFromSelected": "クリックして選択から削除",
    "clickToAddToSelected": "クリックして選択に追加",
    "reportExportIssue": "エクスポートの問題を報告"
  },
  "debugControls": {
    "goBackInTime": "時間を戻る",
    "takeSnapshot": "スナップショットを撮る",
    "goForwardInTime": "時間を進める",
    "saveStateWithSnapshots": "スナップショット付きで状態を保存",
    "resume": "再開",
    "pause": "一時停止",
    "trace": "トレース",
    "tracing": "トレース中",
    "downloadTraceLog": "トレースログをダウンロード"
  },
  "fullscreen": {
    "fullScreen": "フルスクリーン"
  },
  "internetArchive": {
    "searchPlaceholder": "ソフトウェア名を入力するか、上のカテゴリをクリックしてください",
    "go": "検索"
  },
  "basic": {
    "newProgram": "新規プログラム",
    "runFromBeginning": "最初から実行",
    "break": "中断",
    "continueRunning": "実行を継続",
    "stepProgram": "プログラムをステップ実行",
    "resumeOutput": "出力を再開",
    "freezeOutput": "出力をフリーズ",
    "importProgram": "プログラムのインポート...",
    "exportProgram": "プログラムのエクスポート...",
    "renumberProgram": "プログラムの行番号を振り直す",
    "rebuildProgram": "メモリからプログラムを再構築",
    "displaySettings": "表示設定",
    "autoLineNumbering": "自動行番号",
    "capitalizeKeywords": "キーワードを大文字にする",
    "rebuildWarning": "これにより、現在のプログラムがApple IIのメモリから再構築されたバージョンに置き換えられます。保存されていない変更は失われます。よろしいですか？",
    "variable": "変数",
    "value": "値"
  },
  "expectin": {
    "runScript": "スクリプトを実行",
    "stopScript": "スクリプトを停止"
  },
  "saveDisassembly": {
    "title": "逆アセンブルを保存",
    "startAddress": "開始アドレス $",
    "endAddress": "終了アドレス $",
    "includeLabels": "シンボルラベルを含める",
    "separatorLines": "JMP、RTSの後に区切り線を入れる"
  },
  "gamepad": {
    "useArrowKeys": "矢印キーをジョイスティックに",
    "siriusJoyport": "Siriusジョイポートモード"
  },
  "traceSettings": {
    "title": "トレース設定",
    "settings": "設定"
  },
  "linkBuilder": {
    "startupOptionsTab": "起動オプション",
    "speedNames": {
      "warp": "ばかげた速度"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192"
    },
    "slots": {
      "configure": "スロットカードの設定",
      "slot": "スロット {{slot}}:",
      "cardNone": "なし (空)"
    },
    "additionalDiskDrives": "追加ディスクドライブ",
    "slot6Drive1": "スロット 6 ドライブ 1 (フロッピー 1)",
    "slot6Drive2": "スロット 6 ドライブ 2 (フロッピー 2)",
    "slot7Drive1": "スロット 7 ドライブ 1 (ハードディスク 1)",
    "slot7Drive2": "スロット 7 ドライブ 2 (ハードディスク 2)",
    "slot2Drive1": "スロット 2 ドライブ 1 (VERA SD)",
    "slot4Drive1": "スロット 4 ドライブ 1 (VERA SD)",
    "addAdditionalDisk": "交換用の追加ディスクを追加",
    "removeDisk": "このディスクを削除",
    "addAnotherDisk": "別のディスクを追加",
    "diskPlaceholder": "ディスク {num} ファイル名 (例: sideB.woz|シナリオディスク)"
  },
  "startup": {
    "welcome": "Apple2TS へようこそ",
    "subtitle": "TypeScript Apple II エミュレーター",
    "copyright": "(c) {{year}} C.Torrence + 協力者",
    "diskCollections": "ディスクコレクションアイコンをクリック\nして内蔵ディスクやゲームを読込む。"
  },
  "retroControl": {
    "machine": "マシン",
    "fullscreen": "フルスクリーン",
    "diskCollection": "ディスク",
    "diskDrives": "ディスクドライブ",
    "display": "表示",
    "monitorMode": "モニターモード",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "サウンド",
    "options": "オプション",
    "skin": "スキン",
    "personalization": "パーソナライズ",
    "text": "テキスト",
    "background": "背景",
    "border": "枠線",
    "iigsColor": {
      "black": "黒",
      "red": "赤",
      "darkBlue": "濃い青",
      "purple": "紫",
      "darkGreen": "濃い緑",
      "darkGray": "濃い灰色",
      "mediumBlue": "青",
      "lightBlue": "水色",
      "brown": "茶",
      "orange": "オレンジ",
      "lightGray": "薄い灰色",
      "pink": "ピンク",
      "lightGreen": "黄緑",
      "yellow": "黄",
      "aquamarine": "アクアマリン",
      "white": "白"
    },
    "keyboard": "キーボード",
    "joystick": "ジョイスティック",
    "slots": "スロット",
    "devices": "デバイス",
    "printerPort": "プリンターポート",
    "modemPort": "モデムポート",
    "quit": "終了",
    "apple2tsCollection": "Apple2TS コレクション",
    "newReleases": "新着",
    "favorites": "お気に入り",
    "exportDisksToHdv": "ディスクを HDV にエクスポート",
    "noDiskDrivesAvailable": "使用可能なディスクドライブがありません",
    "select": "選択",
    "open": "開く",
    "load": "読み込む",
    "go": "実行",
    "save": "保存",
    "clipboard": "クリップボード",
    "cancelEsc": "キャンセル:Esc",
    "color": "カラー",
    "systemSpeed": "システム速度",
    "other": "その他",
    "timeMachine": "スナップショット",
    "ports": "ポート",
    "language": "言語",
    "retroTheme": "レトロ",
    "lowercaseInput": "小文字入力",
    "openAppleKey": "オープンAppleキー",
    "sortOrder": "並べ替え",
    "card": {
      "empty": "空",
      "mockingboard": "Mockingboard"
    }
  }
}
